// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/attendances",
  Import: "/pyr/attendances",
  ImportOverTime: "/pyr/overtimes",
  ImportLeaves: "/pyr/employee-leaves",
  Summary: "/pyr/attendances/summary",
  SyncLeave: "/pyr/employee-leaves/sync",
  EmployeeLeaveShort: "/pyr/employee-leaves/short",
  SyncTimeAttendance: "/pyr/attendances/sync",
};
